// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lotus-casino-header-tabs {
  position: sticky;
  top: -8px;
  z-index: 20;
  width: 100%;
  background: #080808;
  padding: 8px 0 4px;
  --lotus-tabs-nav-bg: color-mix(in srgb, #f9f9f9 70%, transparent);
}

.lotus-casino-header-tabs__container {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: none;
  padding: 0 4px;
  min-height: 94px;
}

.lotus-casino-header-tabs__container::-webkit-scrollbar {
  display: none;
}

.lotus-casino-header-tabs__tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1 0 94px;
  min-width: 72px;
  max-width: 94px;
  padding: 6px 4px 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.75);
  transition: color 0.15s ease;
  text-decoration: none;
}

.lotus-casino-header-tabs__tab:hover {
  color: #ffffff;
}

.lotus-casino-header-tabs__tab.selected {
  color: #67af7e;
}

.lotus-casino-header-tabs__tab.selected .lotus-casino-header-tabs__title-container {
  font-weight: 700;
}

.lotus-casino-header-tabs__icon-container {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.lotus-casino-header-tabs__tab-img {
  width: 44px;
  height: 44px;
  object-fit: contain;
}

.lotus-casino-header-tabs__tab-img-fallback {
  display: inline-block;
  width: 44px;
  height: 44px;
}

.lotus-casino-header-tabs__title-container {
  font-family: "Lato", sans-serif;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  text-align: center;
  line-height: 1.2;
  max-width: 92px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lotus-casino-header-tabs__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: var(--lotus-tabs-nav-bg) !important;
  color: #1a1a1a;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: opacity 0.15s ease;
}

.lotus-casino-header-tabs__arrow svg {
  width: 16px;
  height: 16px;
  display: block;
}

.lotus-casino-header-tabs__arrow:hover {
  background: var(--lotus-tabs-nav-bg) !important;
  opacity: 0.92;
}

.lotus-casino-header-tabs__arrow--left {
  left: 0;
}

.lotus-casino-header-tabs__arrow--right {
  right: 0;
}

.lotus-casino-header-tabs.left-arrow-hidden .lotus-casino-header-tabs__arrow--left,
.lotus-casino-header-tabs.right-arrow-hidden .lotus-casino-header-tabs__arrow--right {
  display: none;
}

/* Mobile: hide tab scroll arrows — swipe/scroll only */
@media (max-width: 1119px) {
  .lotus-casino-header-tabs__arrow {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LotusCasinoHeaderTabs/LotusCasinoHeaderTabs.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,aAAa;AACf;;AAEA,uDAAuD;AACvD;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".lotus-casino-header-tabs {\n  position: sticky;\n  top: -8px;\n  z-index: 20;\n  width: 100%;\n  background: #080808;\n  padding: 8px 0 4px;\n  --lotus-tabs-nav-bg: color-mix(in srgb, #f9f9f9 70%, transparent);\n}\n\n.lotus-casino-header-tabs__container {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  overflow-x: auto;\n  scrollbar-width: none;\n  padding: 0 4px;\n  min-height: 94px;\n}\n\n.lotus-casino-header-tabs__container::-webkit-scrollbar {\n  display: none;\n}\n\n.lotus-casino-header-tabs__tab {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 1 0 94px;\n  min-width: 72px;\n  max-width: 94px;\n  padding: 6px 4px 8px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  flex-shrink: 0;\n  color: rgba(255, 255, 255, 0.75);\n  transition: color 0.15s ease;\n  text-decoration: none;\n}\n\n.lotus-casino-header-tabs__tab:hover {\n  color: #ffffff;\n}\n\n.lotus-casino-header-tabs__tab.selected {\n  color: #67af7e;\n}\n\n.lotus-casino-header-tabs__tab.selected .lotus-casino-header-tabs__title-container {\n  font-weight: 700;\n}\n\n.lotus-casino-header-tabs__icon-container {\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n\n.lotus-casino-header-tabs__tab-img {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n}\n\n.lotus-casino-header-tabs__tab-img-fallback {\n  display: inline-block;\n  width: 44px;\n  height: 44px;\n}\n\n.lotus-casino-header-tabs__title-container {\n  font-family: \"Lato\", sans-serif;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  text-align: center;\n  line-height: 1.2;\n  max-width: 92px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lotus-casino-header-tabs__arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 50%;\n  background: var(--lotus-tabs-nav-bg) !important;\n  color: #1a1a1a;\n  cursor: pointer;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: opacity 0.15s ease;\n}\n\n.lotus-casino-header-tabs__arrow svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n.lotus-casino-header-tabs__arrow:hover {\n  background: var(--lotus-tabs-nav-bg) !important;\n  opacity: 0.92;\n}\n\n.lotus-casino-header-tabs__arrow--left {\n  left: 0;\n}\n\n.lotus-casino-header-tabs__arrow--right {\n  right: 0;\n}\n\n.lotus-casino-header-tabs.left-arrow-hidden .lotus-casino-header-tabs__arrow--left,\n.lotus-casino-header-tabs.right-arrow-hidden .lotus-casino-header-tabs__arrow--right {\n  display: none;\n}\n\n/* Mobile: hide tab scroll arrows — swipe/scroll only */\n@media (max-width: 1119px) {\n  .lotus-casino-header-tabs__arrow {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
